import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function CTASection() {
  return (
    <section className="py-24 lg:py-32 relative overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 grid-bg opacity-50" />
      <div className="absolute -inset-32 bg-gradient-to-r from-primary/20 via-transparent to-accent/20 blur-3xl" />
      <div className="relative max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display text-4xl sm:text-5xl lg:text-7xl font-black tracking-tighter leading-[1] mb-8"
        >
          ¿Tu marca quiere entrar en <span className="gradient-text">la conversación</span>?
        </motion.h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-10">
          Contanos qué querés mover. Nosotros ponemos la estrategia, los talentos y la producción.
        </p>
        <Link
          to="/contacto"
          data-testid="cta-button"
          className="inline-flex items-center gap-2 px-10 py-4 bg-primary text-primary-foreground font-bold uppercase tracking-widest text-sm rounded-sm hover:opacity-90 transition-opacity"
        >
          Armemos una campaña
        </Link>
      </div>
    </section>
  );
}
